import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function Comment(props) {
  const gray = getColorValue('illustrationGray');
  const blue = getColorValue('illustrationAccent');
  const line = getColorValue('illustrationStroke');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path d="m230.42 86.6797h-186.42v113.5203h186.42z" fill={gray} />
      <path
        d="m137.21 193.17-26.09 4.33s2.51 11.93-3.46 22.68c.8.07 1.6.12 2.42.12 14.99 0 27.13-12.15 27.13-27.13z"
        fill={gray}
      />
      <path
        d="m221.56 93.87c.4-2.24.61-4.62.61-7.14s-.21-4.97-.62-7.23c-2.42-13.49-11.8-21.81-24.94-23.95-2.24-.36-4.59-.55-7.04-.55-2.55 0-5 .2-7.33.59-13.15 2.2-22.51 10.49-24.94 23.91-.41 2.27-.62 4.68-.62 7.23 0 2.52.21 4.9.61 7.14 2.41 13.4 11.77 21.71 24.95 23.91 2.33.39 4.78.59 7.33.59 2.45 0 4.8-.19 7.04-.55 13.16-2.14 22.55-10.47 24.95-23.95z"
        fill={blue}
      />
      <path
        d="m221.56 93.8705c.4-2.24.61-4.62.61-7.14h-65.49c0 2.52.21 4.9.61 7.14 2.41 13.3995 11.77 21.7095 24.95 23.9095 2.33.39 4.78.59 7.33.59 2.45 0 4.8-.19 7.04-.55 13.16-2.14 22.55-10.47 24.95-23.9495z"
        fill={illustrationColors.staticDarkBlue}
      />
      <g clipRule="evenodd" fill={line} fillRule="evenodd">
        <path d="m210.64 92h-42.44v-7h42.44z" />
        <path d="m185.92 109.72v-42.4505h7v42.4505z" />
        <path d="m207.24 132.56h-140.06v-7h140.06z" />
        <path d="m207.24 151.91h-140.06v-7h140.06z" />
        <path d="m171.82 171.25h-104.64v-7h104.64z" />
      </g>
    </svg>
  );
}

export default Comment;
